<div [class]="classes?.previewMainWrapper">
    <div [class]="wrapperClass" [class.mbPreviewHorizontalViewWrapper]="isDeviceMobile$ | async">
        @if (isShowCatalogCard) {
            <div class="preview-image-container" [class.mbPreviewImageContainer]="isDeviceMobile$ | async">
                @if (element?.images?.length) {
                    @let imageSrc = formatImageURL(element.images[0]);
                    @let fallbackSrc = formatImageFallbackURL(element.images[0]);
                    <div
                        class="image-wrapper"
                        [class.resizeble]="data.previewModalSettings.gallery.aspectRatio !== aspectRatio.default"
                    >
                        <picture [spFallbackImg]="fallbackSrc">
                            @if (element?.images[0]?.srcSets?.length) {
                                @for (source of element.images[0].srcSets; track source) {
                                    <source [srcset]="source.url" [media]="source.media" />
                                }
                            }
                            <img [src]="imageSrc" alt="0" />
                        </picture>
                    </div>
                } @else {
                    <div class="blank-wrapper">
                        <img [src]="'./assets/img/websites/lpc-empty-product.png'" alt="product_blank" />
                    </div>
                }
            </div>
            <div [class]="classes?.previewContentWrapper">
                <div class="left-side">
                    <div class="card-title sp-ui-text">
                        <h2>{{ element.name }}</h2>
                    </div>
                    @if (element.shortDescription && previewModalSettings.typography.descriptionSettings.isShow) {
                        <div class="card-description sp-ui-text">
                            <div [innerHTML]="element.shortDescription | spSafeHtml"></div>
                        </div>
                    }
                </div>
                <div class="right-side">
                    <div class="card-price-wrapper sp-ui-text">
                        <div class="card-price-block">
                            @if (element.price !== null && previewModalSettings.typography.priceSettings.isShow) {
                                <p class="card-new-price">
                                    {{ element.price | number: "1.2-2" }} {{ (shopSettings$ | async)?.currency }}
                                </p>
                            }
                            @if (element.oldPrice && previewModalSettings.typography.oldPriceSettings.isShow) {
                                <p class="card-old-price">
                                    {{ element.oldPrice | number: "1.2-2" }} {{ (shopSettings$ | async)?.currency }}
                                </p>
                            }
                        </div>
                        @if (isSubscriptionType) {
                            <p class="subscription-period mb-0">
                                (
                                {{
                                    "widget_product_subscription_period_text"
                                        | translate: { period: subscriptionPeriodKey | translate }
                                }}
                                )
                            </p>
                        }
                    </div>
                    @if (element.price === null && element.variants?.length) {
                        <div class="card-price-block sp-ui-text">
                            @if (
                                element.variants[0]?.price.value && previewModalSettings.typography.priceSettings.isShow
                            ) {
                                <p class="card-new-price">
                                    {{ element.variants[0]?.price.value | number: "1.2-2" }}
                                    {{ (shopSettings$ | async)?.currency }}
                                </p>
                            }
                            @if (
                                element.variants[0]?.oldPrice.value &&
                                previewModalSettings.typography.oldPriceSettings.isShow
                            ) {
                                <p class="card-old-price">
                                    {{ element.variants[0]?.oldPrice.value | number: "1.2-2" }}
                                    {{ (shopSettings$ | async)?.currency }}
                                </p>
                            }
                        </div>
                    }
                    <div class="buttonWrapper">
                        @if (showMoreButton.isShowButton) {
                            <a [class]="buttonClass" class="card-button">
                                {{ showMoreButton.label }}
                            </a>
                        }
                    </div>
                </div>
            </div>
        } @else {
            <div class="hiddenCardContainer">
                <svg xmlns="http://www.w3.org/2000/svg" width="180" height="180" viewBox="0 0 180 180" fill="none">
                    <path
                        d="M48 63C45.5147 63 43.5 65.0147 43.5 67.5V142.5C43.5 144.985 45.5147 147 48 147H132C134.485 147 136.5 144.985 136.5 142.5V67.5C136.5 65.0147 134.485 63 132 63H117.75V60H132C136.142 60 139.5 63.3579 139.5 67.5V142.5C139.5 146.642 136.142 150 132 150H48C43.8579 150 40.5 146.642 40.5 142.5V67.5C40.5 63.3579 43.8579 60 48 60H62.25V63H48Z"
                        fill="#7E8FA5"
                    />
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M55.5 121.5C55.5 120.672 56.1716 120 57 120H85.5C86.3284 120 87 120.672 87 121.5C87 122.328 86.3284 123 85.5 123H57C56.1716 123 55.5 122.328 55.5 121.5ZM55.5 129C55.5 128.172 56.1716 127.5 57 127.5H73.5C74.3284 127.5 75 128.172 75 129C75 129.828 74.3284 130.5 73.5 130.5H57C56.1716 130.5 55.5 129.828 55.5 129Z"
                        fill="#7E8FA5"
                    />
                    <path
                        d="M105.38 76.8796C113.517 68.7423 113.858 55.7619 106.403 47.2179L75.7184 77.903C84.2624 85.3572 97.2422 85.017 105.38 76.8796ZM74.6204 46.1205C66.4831 54.2579 66.1429 67.2377 73.5971 75.7817L104.282 45.0966C95.7381 37.6424 82.7578 37.9831 74.6204 46.1205ZM107.501 79.001C97.8354 88.6664 82.1646 88.6664 72.4991 79.001C62.8336 69.3355 62.8336 53.6647 72.4991 43.9992C82.1646 34.3337 97.8354 34.3337 107.501 43.9992C117.166 53.6647 117.166 69.3355 107.501 79.001Z"
                        fill="#7E8FA5"
                    />
                </svg>
                <p>{{ "hidden_catalog_product_noty" | translate }}</p>
            </div>
        }
    </div>
</div>
